import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { dispatch } from "../utils/events.ts";
import htmx from "htmx.org";

export default class SearchResult extends AlpineComponent {
  public constructor(
    public selected: boolean = false,
    public disabled: boolean = false,
    public index: number = 0,
    public editLink: string = ""
  ) {
    super();
  }

  /**
   * Handles pointerdown events on the search result.
   * Dispatches a custom event when the result is selected.
   * Note: pointerdown is used instead of click to work around a WebView2 focus issue.
   */
  onPointerDown() {
    if (this.disabled) return;
    dispatch("search-result-submitted", this);
  }

  onSearchResultSelected(e: CustomEvent<SearchResult>) {
    this.selected = e.detail.index === this.index;
  }

  onPressEnter() {
    if (this.selected && !this.disabled) {
      if (this.$el.hasAttribute('href')) {
        this.$el.click()
      } else {
        htmx.trigger(this.$el, "pointerdown")
      }
    }
  }

  onPressShiftEnter() {
    if (this.selected && !this.disabled && this.editLink.length > 0) {
      htmx.ajax("get", this.editLink, {})
    }
  }
}
